enum ProductLimitEnum {
  Threshold = 10,
}

export default ProductLimitEnum
